import React, { useEffect, useMemo, useState } from "react";
import { MarketersAnalysis, MarketerTable } from "../../pages";
import { MarketersController } from "../../controllers";
import { object, string } from "yup";
import { toJS } from "mobx";
import { marketersStore } from "../../stores";

const MarketerTableContainer = ({
  marketer,
  setItem,
  setTodoModal,
  setTradingName,
  filterParams,
}) => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const marketersTableQuery = useMemo(() => {
    let query = `offset=${currentPage + 1}&limit=${limit}&type=marketer`;
    // if (marketer) {
    //   query += `&marketer=${marketer}`;
    // }
    if (filterParams) {
      query += `&marketer=${filterParams}`;
    }
    return query;
  }, [currentPage, limit, filterParams]);

  const { isLoading, data, isFetching } =
    MarketersController.useGetMarketersBusinesses(
      marketersTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  return (
    <MarketerTable
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      marketerAnalysis={toJS(marketersStore.marketerAnalysis)}
      setItem={setItem}
      setTradingName={setTradingName}
      setTodoModal={setTodoModal}
    />
  );
};

export default MarketerTableContainer;
